import * as Redux from 'redux';
import { ReduxPromiseAction } from '../app/app.types';
import { SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { ANTI_IDLE, CHECKIN, GET_ATTENDANCE, UNCHECKIN } from './attendance.constants';
import { AttendanceActionTypes, AttendanceEntity, CheckinActionTypes, CheckinEntity } from './attendance.types';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const getAttendance: Redux.ActionCreator<
  ReduxPromiseAction<
    AttendanceActionTypes, SimpleResponse<AttendanceEntity>
  >
> = (from: number, to: number): ReduxPromiseAction<AttendanceActionTypes, SimpleResponse<AttendanceEntity>> => ({
  type: GET_ATTENDANCE,
  payload: callApi(
    process.env.REACT_APP_API + '/attendance/' + from + '/' + to,
    true,
    {
      method: 'GET',
      headers: {
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const checkinToday: Redux.ActionCreator<
  ReduxPromiseAction<
    CheckinActionTypes, SimpleResponse<CheckinEntity>
  >
> = (
  memberId: string, 
  programId: number,
  accountId?: number,
  packageId?: number,
  noShow?: boolean
): ReduxPromiseAction<CheckinActionTypes, SimpleResponse<CheckinEntity>> => ({
  type: CHECKIN,
  payload: callApi(
    process.env.REACT_APP_API + '/attendance/checkin',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({memberId, programId, accountId, packageId, noShow})
    }
  )
});

export const unCheckinToday: Redux.ActionCreator<
  ReduxPromiseAction<
    CheckinActionTypes, SimpleResponse<CheckinEntity>
  >
> = (memberId: string, time: number): ReduxPromiseAction<CheckinActionTypes, SimpleResponse<CheckinEntity>> => ({
  type: UNCHECKIN,
  payload: callApi(
    process.env.REACT_APP_API + '/attendance/checkin',
    true,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({memberId, time})
    }
  )
});

export const faceCheckin: Redux.ActionCreator<
  ReduxPromiseAction<
    CheckinActionTypes, SimpleResponse<CheckinEntity>
  >
> = (file: File, programId: number): ReduxPromiseAction<CheckinActionTypes, SimpleResponse<CheckinEntity>> => ({
  type: CHECKIN,
  payload: callApi(
    process.env.REACT_APP_API + '/attendance/checkin/face',
    true,
    {
      method: 'POST',
      headers: {
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: ((): FormData => {
        let formData = new FormData();
        formData.append('file', file);

        if (programId !== undefined) { 
          formData.append('programId', JSON.stringify(programId));
        } else {
          formData.append('programId', JSON.stringify(0));
        }
        
        return formData;
      })()
    }
  )
});

/**
 * This should be only used in Attendance Mode to prevent being idle.
 */
export const antiIdle: Redux.ActionCreator<
  ReduxPromiseAction<
    CheckinActionTypes, SimpleResponse<{}>
  >
> = (): ReduxPromiseAction<CheckinActionTypes, SimpleResponse<{}>> => ({
  type: ANTI_IDLE,
  payload: callApi(
    process.env.REACT_APP_API + '/account/refresh/' + pickAuthOrImpersonationToken(),
    true,
    {
      method: 'GET'
    }
  )
});



// WEBPACK FOOTER //
// ./src/attendance/attendance.actions.tsx